import { combineReducers } from 'redux';
import { BlockTypes } from '../../action_types';
import { arrayToObject, removeItem, insertItem, updateObjectInArray } from '@app/utils/helpers';

function all(state = {}, action) {
  switch (action.type) {
    case BlockTypes.GET_BLOCKS_SUCCESS:
      return { ...state, ...arrayToObject(action.data.results) };
    case BlockTypes.GET_BLOCK_SUCCESS:
    case BlockTypes.CREATE_BLOCK_SUCCESS:
    case BlockTypes.UPDATE_BLOCK_SUCCESS:
      return {
        ...state,
        [action.data.id]: action.data,
      };
    case BlockTypes.DELETE_BLOCK_SUCCESS:
      const { [action.id]: _, ...newState } = state;
      return newState;
    default:
      return state;
  }
}

function ui(state = [], action) {
  switch (action.type) {
    case BlockTypes.GET_BLOCKS_SUCCESS:
      return action.data.results;
    case BlockTypes.CREATE_BLOCK_SUCCESS:
      return insertItem(state, action.data);
    case BlockTypes.UPDATE_BLOCK_SUCCESS:
      return updateObjectInArray(state, action.data);
    case BlockTypes.DELETE_BLOCK_SUCCESS:
      return removeItem(state, action.id);
    default:
      return state;
  }
}

function meta(state = {}, action) {
  switch (action.type) {
    case BlockTypes.GET_BLOCKS_SUCCESS:
      const { results, ...rest } = action.data;
      return { ...state, ...rest };
    case BlockTypes.DELETE_BLOCK_SUCCESS: {
      const { total } = state;
      return { ...state, total: total - 1 };
    }
    default:
      return state;
  }
}

export default combineReducers({
  all,
  ui,
  meta,
});
